import React from 'react';
import { formatDate, numberFormat } from '../../../util/araknerdlib';
import MiniStatCard from '../../Banking/MiniStatCard';

const WalletProfileMetric = ({deposits, withdraws, balance, last_transaction}) => {
    return (
        <div className="row">

              <div className="col-md-3">
                    <MiniStatCard
                        icon="fa-circle-plus"
                        label="Total Deposits"
                        value={numberFormat(deposits)}
                        tone="primary"
                        meta=""
                        hint="Accumulated billed amount."
                        loading={!deposits}
                    />
                </div>
 
                <div className="col-md-3">
                    <MiniStatCard
                        icon="fa-circle-minus"
                        label="Total Withdraws"
                        value={numberFormat(withdraws)} 
                        tone="danger"
                        meta=""
                        hint="Accumulated paid amount."
                        loading={!withdraws}
                        />
                </div>
               
               <div className="col-md-3">
                    <MiniStatCard
                        icon="fa-balance-scale"
                        label="Wallet Balance" 
                        value={numberFormat(balance)} 
                        tone="success"
                        meta=""
                        hint="Current fees balance."
                        loading={!balance}
                        />
                </div>

                 <div className="col-md-3">
                    <MiniStatCard
                        icon="fa-clock-rotate-left"
                        label="Last Transaction" 
                        value={last_transaction ? `${numberFormat(last_transaction.amount)}` : "N/A"}
                        tone="primary"
                        meta={last_transaction ? formatDate(last_transaction.created_at) : "N/A"}
                        hint={"Last student transaction type: " + (last_transaction ? `${last_transaction.transaction_type === "cash_in" ? "Deposit" : "Withdraw"}` : "No transactions yet")}
                        loading={!balance}
                        />
                </div>

            </div>  
    );
};

export default WalletProfileMetric;